var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "topnav-product-highlight-container" },
    _vm._l(_vm.localSkus, function(sku) {
      return _c("NsProductCard", {
        key: sku,
        staticClass: "topnav-product-highlight",
        attrs: {
          "no-action": "",
          "hide-variant-selector": "",
          "hide-favorites": "",
          sku: sku
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }